<div class="wrapper" [ngClass]="{'checkout-item': _variant === VARIANT_CHECKOUT_ITEM, 'cart-item': _variant === VARIANT_CART_ITEM}">
  @if (loading) {
    <app-spinner></app-spinner>
  }
  @if (!loading) {
    <div class="container">
      <div class="item-contents flex">
        <div class="image-container">
          <img [src]="itemImage">
        </div>
        <div class="item-details flex-grow-1">
          <p class="title">{{title}}</p>
          @if (!feature.endPubDate) {
            <p>
              <span>Promo Date:</span> {{pubDate}}
            </p>
          }
          @if (feature.endPubDate) {
            <p>
              <span>Promo Date:</span> Starting on {{pubDate}}
            </p>
          }
          @if (detailsExpanded) {
            <div class="expanded-details">
              <p><span>Promo Site:</span> {{siteName}}</p>
              <p><span>Genre/Product:</span> {{siteAdvertName}}</p>
              <p><span>Book Price:</span> {{bookPrice}}</p>
            </div>
          }
          <div class="edit-details">
            <a (click)="toggleDetails()">{{detailsExpanded ? 'Collapse Details' : 'Details'}}</a>
            <div class="dot">&#183;</div>
            <a (click)="editFeature()">Edit</a>
          </div>
        </div>
        <div class="flex align-items-end justify-content-end flex-direction-column">
          @if (hasSpeculativeDiscount) {
            <p class="speculative-discount-orinal-price">{{ price | currency:'USD' }}</p>
          }
          <p class="total-amount">{{paymentAmount | currency:'USD'}}</p>
          @if (hasSpeculativeDiscount) {
            <div class="speculative-discount">{{ speculativeDiscountText }}</div>
          }
          @if (!hasSpeculativeDiscount && showMembershipSaving) {
            <div>
              @if (qualifiesForMembershipUpsell) {
                <div class="speculative-discount-upsell flex">
                  <div class="gold">
                    <div class="wwm-icon"></div>
                  </div>
                  {{ upsellText }}
                </div>
              }
            </div>
          }
        </div>
      </div>
      @if (hasValidPromoCode || (_variant === VARIANT_CART_ITEM && hasSpeculativeDiscount)) {
        <div class="price-section">
          @for (detail of discountDetails; track detail) {
            <div class="sub-section">
              <p>{{ detail.label }}</p>
              <p class="ml-10">{{ detail.value | currency:'USD' }}</p>
            </div>
          }
          <div class="sub-section">
            <p>Promo Price</p>
            <p class="ml-10">{{ paymentAmount | currency:'USD' }}</p>
          </div>
        </div>
      }
      <!-- <div class="cart-price flex">
      <div class="flex-grow-1"></div>
      <div class="speculative-discount" *ngIf="hasSpeculativeDiscount">{{ speculativeDiscountText }}</div>
      <p class="total-amount ml-10">${{paymentAmount?.toFixed(2)}}</p>
    </div> -->
    <div class="button regular close" (click)="openConfirmationModal()"><span class="icon">&#x00D7;</span></div>
  </div>
}
</div>
<app-confirm-modal
  [modalId]="modalId"
  [text]="confirmText"
  [buttonText]="buttonText"
  (confirmChoice)="onItemRemove($event)"
></app-confirm-modal>
<app-error-modal [modalId]="'cart-item-error-modal'" [text]="errorText"></app-error-modal>
